<div class="alert" role="alert">
    {{ 'No request selected' | translate }}
</div>
